import React from "react";

/**
 * component svg menu button
 */
const MenuButton = function (props) {

    return (

        <svg id="menu-button" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"
             x="0px" y="0px"
             viewBox="0 0 1000 1000">
            <path className="st0" d="M214,482.1"/>
            <line className="st-t" x1="172" y1="482.1" x2="172" y2="482.1"/>
            <line className="st-m" x1="500" y1="482.1" x2="500" y2="482.1"/>
            <line className="st-b" x1="828" y1="482.1" x2="828" y2="482.1"/>
        </svg>
    );
};

export default MenuButton;
